import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

// Inline "claim this badge" form: tell Steve what you did, he approves, points land.
export default function BadgeClaimForm({ badge, onSubmit, onCancel, submitting }) {
  const [reason, setReason] = useState("");
  return (
    <div className="rounded-xl border border-[#C85A38]/30 bg-white p-3" data-testid={`claim-form-${badge.id}`}>
      <div className="flex items-center gap-2.5 mb-2">
        <span className="text-2xl">{badge.icon}</span>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm text-[#1A1A1A]">{badge.name}</p>
          <p className="text-[11px] text-[#1A1A1A]/55">{badge.description}</p>
        </div>
        <span className="text-sm font-semibold text-[#C85A38] flex-shrink-0">+{badge.points}</span>
      </div>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="When did you do it? One line is plenty — Steve just needs to say yes."
        rows={2}
        className="w-full px-3 py-2 text-sm border border-stone-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C85A38]/20 resize-none mb-2 bg-[#FBF7F1]"
        data-testid={`claim-reason-${badge.id}`}
      />
      <div className="flex gap-2">
        <Button
          size="sm"
          onClick={() => onSubmit(badge.id, reason)}
          disabled={submitting || !reason.trim()}
          className="flex-1 bg-[#C85A38] hover:bg-[#A84830] text-white rounded-full text-xs h-8"
          data-testid={`claim-submit-${badge.id}`}
        >
          {submitting ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Send className="w-3.5 h-3.5 mr-1" /> Send to Steve</>}
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel} className="rounded-full text-xs h-8" data-testid={`claim-cancel-${badge.id}`}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
